import { ISaveLessonParams } from 'interface/savedLesson';
import { API_V4_BASE_URL } from 'settings';
import { put, get } from './api';

export const saveLesson = (lesCod: string | number) => {
  return put({
    url: `/learner/lessons/${lesCod}/save`,
    baseURL: API_V4_BASE_URL,
  }).then((response) => response.data.data);
};

export const getLessonSaved = (lesCod: string) => {
  return get({
    url: `/learner/lessons/${lesCod}/save`,
    baseURL: API_V4_BASE_URL,
  }).then((response) => response.data.data);
};

export const getAllSavedLessons = ({ page, search, order }: ISaveLessonParams) => {
  return get({
    url: `/learner/savedlessons${order ?? ''}`,
    baseURL: API_V4_BASE_URL,
    params: {
      page,
      search: search || null,
    },
  }).then((response) => response.data);
};
